export default __webpack_public_path__ + "static/media/tilegamereveal.31b0350d.mp3";